<template>
	<div>
        <ren1-sunset-notice :pool="currentPoolObj" />
        <div class="">
            <div class='exchange'>
                <div class='exchangefields'>
                    <fieldset class='item'>
                        <legend>From:</legend>
                        <div class='maxbalance' @click='set_max_balance'>
                            Max:
                            <span v-show="!currentPoolObj.isFactoryOnlyPool && coins[from_currency_id].isSynth && maxBalanceText != '0.00'">
                                {{maxSynthText}}/
                            </span>
                            <span>{{maxBalanceText}}</span>
                            <span v-show='susdWaitingPeriod' class='susd-waiting-period'>
                                <span class='tooltip'>
                                    <img src='@/assets/clock-regular.svg' class='icon small'>
                                    <span class='tooltiptext'>
                                        Cannot transfer during waiting period.
																				{{ (susdWaitingPeriodTime).toFixed(0) }} secs left.
                                    </span>
                                </span>
                            </span>
                            <span v-show="!currentPoolObj.isFactoryOnlyPool && coins[from_currency_id].isSynth && maxBalanceText != '0.00'" class='tooltip'> [?]
                                <span class='tooltiptext long'>
                                    Max transferrable amount is {{ maxSynthText }}. You can free the remaining balance by settling.
                                </span>
                            </span>
                        </div>
                        <ul>
                            <li>
                                <input type="text" id="from_currency" :disabled='disabled' name="from_currency" value='0.00'
                                :style = "{backgroundColor: fromBgColor}"
                                @input='set_to_amount'
                                v-model='fromInput'>
                                <p class='actualvalue' v-show='swapwrapped && currentPoolObj.isLendingPool'>
                                    ≈ {{toFixed(actualFromValue)}} {{fromSymbol}}
                                </p>
                                <p class='actualvalue' v-show="currentPoolObj.referenceAsset !== REFERENCE_ASSETS.USD && !currentPoolObj.isLendingPool">
                                    ≈ ${{ actualFromValue }}
                                </p>
                            </li>
                            <li class='coins' v-for='(currency, i) in Object.keys(currencies)'>
                                <input type="radio" :id="'from_cur_'+i" name="from_cur" :value='i' v-model='from_currency'>
                                <label :for="'from_cur_'+i">
                                    <img
                                        :class="{'token-icon': true, [currency+'-icon']: true, 'y': swapwrapped}"
                                        :src='getTokenIcon(currency)'>
                                    <span>{{currentPoolObj.isFactoryOnlyPool ? currencies[currency] : coins[currency].symbol}}</span>
                                </label>
                            </label>
                            </li>
                        </ul>
                    </fieldset>
                    <fieldset class='item iconcontainer' @click='swapInputs'>
                        <img :src="publicPath + 'exchange-alt-solid.svg'" id='exchangeicon'/>
                    </fieldset>
                    <fieldset class='item'>
                        <legend>To:</legend>
                        <div class='maxbalance2'>Max: <span></span> </div>
                        <ul>
                            <li>
                                <input type="text"
                                id="to_currency"
                                name="to_currency"
                                value="0.00"
                                disabled
                                :style = "{backgroundColor: bgColor}"
                                v-model='toInput'>
                                <p class='actualvalue' v-show='swapwrapped && currentPoolObj.isLendingPool'>
                                    ≈ {{toFixed(actualToValue)}} {{toSymbol}}
                                </p>
                                <p class='actualvalue' v-show="currentPoolObj.referenceAsset !== REFERENCE_ASSETS.USD && !currentPoolObj.isLendingPool">
                                    ≈ ${{ actualToValue }}
                                </p>
                            </li>
                            <li class='coins' v-for='(currency, i) in Object.keys(currencies)'>
                                <input type="radio" :id="'to_cur_'+i" name="to_cur" :value='i' v-model='to_currency'>
                                <label :for="'to_cur_'+i">
                                    <img
                                        :class="{'token-icon': true, [currency+'-icon']: true, 'y': swapwrapped}"
                                        :src='getTokenIcon(currency)'>
                                    <span>{{currentPoolObj.isFactoryOnlyPool ? currencies[currency] : coins[currency].symbol}}</span>
                                </label>
                            </label>
                            </li>
                        </ul>
                    </fieldset>
                </div>
                <p class='exchange-rate'>
                    Exchange rate
                    <span @click='swapExchangeRate' class='clickable underline'>
                        {{getPair(swaprate)}}
                        <img :src="publicPath + 'sync-solid.svg'" class='swaprates-icon'>
                    </span> (including fees):
                    <span id="exchange-rate" @click='swapExchangeRate' class='clickable'>
                        {{exchangeRateSwapped}}
                    </span>
                </p>
                <p class='exchange-rate' v-if="currentPoolObj.cryptoPool || currentPoolObj.isStablePoolWithSpecialUnpeggedAssets">
                    Price impact: <span v-if='cryptoTradeSlippage > 0' :class="{ 'price-impact': true, red: cryptoTradeSlippage > 0.03 }">{{(cryptoTradeSlippage * 100).toFixed(2)}}%</span><span v-else>–</span>
                </p>
                <ul>
                    <li v-if="!currentPoolObj.isFactoryOnlyPool">
                        <input id='swapw' type='checkbox' name='swapw' v-model = 'swapwrapped'>
                        <label for='swapw' v-show = "currentPoolObj.isLendingPool || currentPoolObj.isMetaPool">Swap wrapped</label>
                    </li>
                    <li>
                        <input id='swapWrappedEth' type='checkbox' name='swapWrappedEth' v-model = 'swapWrappedEth'>
                        <label for='swapWrappedEth' v-show = "currentPoolObj.allowTradingEth">Swap Wrapped {{config.nativeCurrency.symbol}}</label>
                    </li>
                </ul>
                <high-usd-slippage-notice
                    :slippage="effectiveMaxSlippage"
                    :amount="toInput"
                    :address="toCoin.address"
                />
                <div>
                    <button class='simplebutton advancedoptions' @click='showadvancedoptions = !showadvancedoptions'>
                        Advanced options
                        <span v-show='!showadvancedoptions'>▼</span>
                        <span v-show='showadvancedoptions'>▲</span>
                    </button>
                    <div v-show='showadvancedoptions'>
                        <fieldset>
                            <legend>Advanced options:</legend>
                            <div id='max_slippage'><span>Max slippage:</span>
                                <input id="slippage05" type="radio" :checked="customSlippageDisabled && effectiveMaxSlippage === 0.5" @click='maxSlippage = 0.5; customSlippageDisabled = true'>
                                <label for="slippage05">0.5%</label>

                                <input id="slippage02" type="radio" :checked="customSlippageDisabled && effectiveMaxSlippage === 0.1" @click='maxSlippage = 0.1; customSlippageDisabled = true'>
                                <label for="slippage02">0.1%</label>

                                <input id="custom_slippage" type="radio" :checked="!customSlippageDisabled" @click='customSlippageDisabled = false'>
                                <label for="custom_slippage" @click='customSlippageDisabled = false'>
                                    <input type="text" id="custom_slippage_input" :disabled='customSlippageDisabled' name="custom_slippage_input" v-model='maxInputSlippage'> %
                                </label>
                                <span class='tooltip' v-show='showSlippageTooLow'>
                                    <img class='icon small hoverpointer warning' :src="publicPath + 'exclamation-circle-solid.svg'">
                                    <span class='tooltiptext'>
                                        Max slippage value is likely too low and the transaction may fail
                                    </span>
                                </span>
                            </div>
                            <gas-price></gas-price>
                        </fieldset>
                    </div>
                </div>
								<div class='simple-error' v-show='errorEstimating'>
										Error estimating gas, your transaction may fail
								</div>

                <p class='simple-error' v-if="exchangeRate <= 0.98 && !currentPoolObj.containsSynthCoin && !currentPoolObj.cryptoPool && !currentPoolObj.isStablePoolWithSpecialUnpeggedAssets">
                    Warning! Exchange rate is too low!
                </p>
                <p class='simple-error' v-else-if="exchangeRate <= 0.95 && !currentPoolObj.cryptoPool && !currentPoolObj.isStablePoolWithSpecialUnpeggedAssets">
                    Warning! Exchange rate is too low!
                </p>
                <p class='simple-error' v-else-if="(currentPoolObj.cryptoPool || currentPoolObj.isStablePoolWithSpecialUnpeggedAssets) && cryptoTradeSlippage > 0.03">
                    Warning! Price impact is high!
                </p>
                <p class='trade-buttons' v-show="currentPoolObj.coins && currentPoolObj.coins.some(({ id }) => id === 'renbtc')">
                    <a href='https://bridge.renproject.io/'>Mint/redeem renBTC</a>
                </p>
                <p class='trade-buttons' v-show="currentPoolObj.coins && currentPoolObj.coins.some(({ id }) => id === 'tbtc')">
                    <a href='https://dapp.tbtc.network/'>Mint/redeem tBTC</a>
                </p>
                <p class='trade-buttons'>
                    <button id="trade" @click='handle_trade'>
                        Sell <span class='loading line' v-show='loadingAction'></span>
                    </button>
                </p>
                <div class='simple-error' v-if='currentPoolObj.isFactoryOnlyPool && currentPoolObj.factoryVersion === 2 && currentPoolObj.coins.every(({ poolBalance }) => parseFloat(poolBalance) === 0)'>
                    <span>This pool is still empty. It needs to be seeded with an initial deposit in order to enable swaps.</span>
                </div>
                <div class='info-message gentle-message waiting-message' v-show='show_loading'>
                    <span v-html='waitingMessage'></span>
                    <span class='loading line'></span>
                </div>
                <p class='simple-error' id='no-balance' v-show='selldisabled'>
                    Not enough balance for {{currentPoolObj.isFactoryOnlyPool ? (currencies && currencies[from_currency_id]) : coins[from_currency_id].symbol}}. <span>Swap is not available.</span>
                </p>
                <div class='simple-error pulse' v-show="susdWaitingPeriod">
                    Cannot transfer {{ waitingAsset }} during waiting period.
										{{ (susdWaitingPeriodTime).toFixed(0) }} secs left.
                </div>
                <div class='info-message gentle-message' v-show='estimateGas'>
                    Estimated tx cost: ${{ (estimateGas * gasPrice / 1e9 * ethPrice).toFixed(config.display.txCostPrecision) }}
                </div>

            </div>
            <div class='modal' v-show='showFailedGasEstimationModal' @click.self='showFailedGasEstimationModal = false'>
                <div class='modal-content failed-gas-estimation window white'>
                    <fieldset>
                        <legend class='redwarning'>
                            Risk of transaction not succeeding
                        </legend>
                        <div class='content'>
                            <p class='simple-error'>
                                Gas estimation for this transaction failed, which means there's a high probability that this transaction will fail if submitted.
                            </p>
                        </div>
                        <div class="button-container">
                            <button @click='showFailedGasEstimationModal = false' class='buttoncancel'>Cancel</button>
                            <button @click='bypassGasEstimationFailureWarning' class='buttonred'> Submit anyway </button>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
</div>
</template>

<script>
    import * as common from '../../utils/common.js'
    import config from '@/constants/config'
    import { notify, notifyHandler, notifyNotification } from '../../init'
    import { getters, contract as currentContract, gas as contractGas} from '../../contract'
    import * as helpers from '../../utils/helpers'
    import getPricesForAssets from '@/utils/data/getPricesForAssets'
    import { getPricesArrayForTokens } from '@/utils/data/getPricesForTokens'
    import { contractAbis } from '@/constants/abis'
    import coins from '@/constants/coins'
    import pools from '@/constants/pools'
    import * as priceStore from '../common/priceStore'
    import { callMethod, sendSafe } from '@/utils/Calls'
    import { truncWithXSignificantDecimals } from '@/utils/Number'
    import BN from 'bignumber.js'
    const REFERENCE_ASSETS = require('@/constants/reference-assets.js');

    import * as gasPriceStore from '../common/gasPriceStore'
    import GasPrice from '../common/GasPrice.vue'

    import * as errorStore from '../common/errorStore'
		import { ethers } from 'ethers';

    import BigNumber from 'bignumber.js'
    import HighUsdSlippageNotice from '@/components/common/HighUsdSlippageNotice'
    import Ren1SunsetNotice from '@/components/common/Ren1SunsetNotice'

    let { setIntervalAsync, clearIntervalAsync } = require('set-interval-async/dynamic')

    var cBN = (val) => new BigNumber(val);
    const allCoins = coins;


	export default {

        components: {
            GasPrice,
            HighUsdSlippageNotice,
            Ren1SunsetNotice,
        },

        data: () => ({
            coins,
            config,
            REFERENCE_ASSETS,
						errorEstimating: null,
            showFailedGasEstimationModal: false,
            disabled: true,
            from_currency: 0,
            from_currency_id: Object.values(coins)[0].id,
            to_currency: 1,
            to_currency_id: Object.values(coins)[1].id,
            inf_approval: true,
            fromInput: '1.00',
            toInput: 0,
            updateTimer: null,
            poolReferenceAssetUsdPrice: null,
            poolAssetsUsdPrice: null,
            maxBalance: -1,
            maxSlippage: null,
            maxSynthBalance: -1,
            susdWaitingPeriod: false,
            susdWaitingPeriodTime: 0,
            maxBalanceText: 0,
            maxSynthText: 0,
						waitingAsset: 'sBTC',

            promise: helpers.makeCancelable(Promise.resolve()),
            promise2: helpers.makeCancelable(Promise.resolve()),
            promise3: helpers.makeCancelable(Promise.resolve()),
            exchangeRate: 'Not available',
            cryptoTradeSlippage: undefined,
            swaprate: false,
            bgColor: '#505070',
            fromBgColor: 'blue',
            maxInputSlippage: '',
            customSlippageDisabled: true,
            swapwrapped: false,
            swapWrappedEth: false,
            coinsContractsArray: {},
            c_rates: [],
            get showadvancedoptions() {
                // TODO improve by calculating usd value of input and using this in the condition
                // deciding whether to show advanced options, rather than a fixed number of BTC/ETH
                const poolReferenceAsset = pools.getById(currentContract.currentContract, false)?.referenceAsset;
                return (
                    localStorage.getItem('advancedoptions') === 'true' ||
                    +this.fromInput > 5000 ||
                    (poolReferenceAsset === REFERENCE_ASSETS.BTC && +this.fromInput > 0.5) ||
                    (poolReferenceAsset === REFERENCE_ASSETS.ETH && +this.fromInput > 5)
                );
            },
            set showadvancedoptions(val) {
                localStorage.setItem('advancedoptions', val)
            },
            show_loading: false,
            waitingMessage: '',
            userInteracted: false,

            estimateGas: 0,
            ethPrice: 0,
            icontype: '',
            loadingAction: false,

            interval: null,
        }),
        async created() {
            this.$watch(()=>currentContract.default_account, (val, oldval) => {
                if(!val || !oldval) return;
                if(val.toLowerCase() != oldval.toLowerCase()) this.mounted();
            })
            this.$watch(()=>currentContract.initializedContracts, val => {
                if(val) this.mounted();
                console.timeEnd('initswap')
            })
        },
        watch: {
            from_currency(val, oldval) {
                if(val == this.to_currency) {
                    this.to_currency = oldval;
                }
                //this.swapExchangeRate()
                this.from_cur_handler()
            },
            swapWrappedEth() {
                this.from_cur_handler()
            },
            to_currency(val, oldval) {
                //this.swapExchangeRate()
                this.to_cur_handler()
            },
            swapwrapped() {
                this.mounted()
            },
            maxBalance(val) {
                let amount = val / this.precisions[this.from_currency]

                this.maxBalanceText = currentContract.default_account ? this.toFixed(amount) : 0;
            },
            maxSynthBalance(val) {
                if(isNaN(val)) return '0.00';
                this.maxSynthText = this.toFixed(val)
            },
            triggerEstimateGas: {
                handler: async function triggerEstimateGas() {
                    let i = this.from_currency
                    let j = this.to_currency
                    let promises = await Promise.all([helpers.getETHPrice()])
                    this.ethPrice = promises[0]
                    //this.estimateGas = this.swapwrapped ? contractGas.swap[this.currentPool].exchange(i, j) / 2 : contractGas.swap[this.currentPool].exchange_underlying(i, j) / 2
                },
                immediate: true
            },
            fromInput() {
                this.userInteracted = true
            },
        },
        computed: {
            currentPoolObj() {
                return pools.getById(this.currentPool);
            },
            precisions() {
                let abi = contractAbis[currentContract.currentContract]
                if(this.currentPoolObj.isFactoryOnlyPool && this.currentPoolObj.isMetaPool) {
                    if(!this.swapwrapped) return abi.meta_coin_precisions;
                    if(this.swapwrapped) return abi.wrapped_precisions;
                }
                // if(this.currentPoolObj.isFactoryOnlyPool && this.currentPoolObj.factoryVersion === 2) {
                //     if(this.currentPoolObj.isMetaPool && !this.swapwrapped) return abi.meta_coin_precisions;
                //     if(this.currentPoolObj.isMetaPool && this.swapwrapped) return abi.wrapped_precisions;
                // }
                if(this.is_meta && this.swapwrapped) return abi.meta_wrapped_precisions
                if(this.is_meta && !this.swapwrapped) return abi.meta_coin_precisions
                if(this.swapwrapped) return abi.wrapped_precisions;
                return abi.coin_precisions
            },
            actualFromValue() {
                if (this.swapwrapped && this.currentPoolObj.isLendingPool) {
                    return (this.fromInput * this.c_rates[this.from_currency] * this.toFixed(this.precisions[this.from_currency]));
                }

                if (this.currentPoolObj.referenceAsset === REFERENCE_ASSETS.CRYPTO || (this.currentPoolObj.referenceAsset !== REFERENCE_ASSETS.USD && !this.currentPoolObj.isLendingPool)) {
                    if (!this.poolAssetsUsdPrice) return;
                    return (this.fromInput * this.poolAssetsUsdPrice[this.from_currency]).toFixed(2)
                }
            },
            actualToValue() {
                if (this.swapwrapped && this.currentPoolObj.isLendingPool) {
                    return (this.toInput * this.c_rates[this.to_currency] * this.toFixed(this.precisions[this.to_currency]));
                }

                if (this.currentPoolObj.referenceAsset === REFERENCE_ASSETS.CRYPTO || (this.currentPoolObj.referenceAsset !== REFERENCE_ASSETS.USD && !this.currentPoolObj.isLendingPool)) {
                    if (!this.poolAssetsUsdPrice) return;
                    return (this.toInput * this.poolAssetsUsdPrice[this.to_currency]).toFixed(2)
                }
            },
            ...getters,
            currencies() {
                const pool = pools.getById(currentContract.currentContract);
                let currencies;

                if (pool.isFactoryOnlyPool) {
                    const { coins, metaCoins } = pool;
                    let factoryCurrencies = (!this.swapwrapped && pool.isMetaPool) ?
                        (coins.slice(0, -1).concat(metaCoins)) :
                        coins;

                    if (pool.cryptoPool && pool.allowTradingEth && !this.swapWrappedEth) {
                        factoryCurrencies = factoryCurrencies.map((coin) => (
                            coin.address.toLowerCase() === allCoins[config.nativeAssetErc20WrapperId].address.toLowerCase() ? allCoins[config.nativeAssetId] : coin
                        ))
                    } else if (pool.cryptoPool && pool.allowTradingEth && this.swapWrappedEth) {
                        factoryCurrencies = factoryCurrencies.map((coin) => (
                            coin.address.toLowerCase() === allCoins[config.nativeAssetErc20WrapperId].address.toLowerCase() ? allCoins[config.nativeAssetErc20WrapperId] : coin
                        ))
                    }

                    currencies = helpers.arrayToHashmap(factoryCurrencies.map(({ symbol }, i) => [`${i}`, symbol.toLowerCase()]));
                } else {
                    if (pool.isMetaPool && !this.swapwrapped) {
                        currencies = getters.meta_currencies();
                    } else if (pool.isLendingPool && !this.swapwrapped) {
                        currencies = getters.lending_currencies();
                    } else if (pool.allowTradingEth && !this.swapWrappedEth) {
                        currencies = helpers.arrayToHashmap(
                            Array.from(Object.entries(getters.currencies())).map(([lc, uc]) => (
                                lc === 'weth' ?
                                    ['eth', 'ETH'] :
                                    [lc, uc]
                            ))
                        )
                    } else {
                        currencies = getters.currencies();
                    }
                }

                return currencies;
            },
            absolute_currencies() {
                const pool = pools.getById(currentContract.currentContract);

                if (pool.isMetaPool) return getters.meta_currencies();
                if (pool.isLendingPool) return getters.lending_currencies();
                return getters.currencies();
            },
            minAmount() {
                return pools.getById(currentContract.currentContract).referenceAsset === REFERENCE_ASSETS.USD ?
                    0.01 : 1e-8;
            },
            selldisabled() {
                return this.maxBalance != -1 && +this.fromInput > +this.maxBalance / this.precisions[this.from_currency] && this.userInteracted
            },
            notEnoughBalanceSynth() {
                return coins[this.from_currency_id].isSynth && cBN(this.fromInput).gt(cBN(this.maxSynthBalance))
            },
            isCryptoPool() {
                return pools.getById(currentContract.currentContract).cryptoPool;
            },
            exchangeRateSwapped() {
                if(this.swaprate)
                    return this.isCryptoPool ?
                        truncWithXSignificantDecimals(1 / this.exchangeRate) :
                        (1 / this.exchangeRate).toFixed(4)
                else
                    return this.exchangeRate
            },
            publicPath() {
                return process.env.BASE_URL
            },
            gasPrice() {
                return gasPriceStore.getGasFields({ forcePreEip1559: true }).gasPrice / 1e9
            },
            triggerEstimateGas() {
                return this.swapwrapped, this.from_currency, this.to_currency, Date.now()
            },
            showSlippageTooLow() {
                return +this.effectiveMaxSlippage < 0.1
            },
            fromSymbol() {
                const currentPoolObj = this.currentPoolObj;

                if (currentPoolObj.isFactoryOnlyPool && currentPoolObj.factoryVersion === 1) {
                    const { coins, metaCoins } = currentPoolObj;
                    return (coins.slice(0, -1).concat(metaCoins))[this.from_currency].symbol;
                } else if (currentPoolObj.isFactoryOnlyPool && currentPoolObj.factoryVersion === 2) {
                    const { isMetaPool, coins, metaCoins } = currentPoolObj;
                    return isMetaPool ?
                        (coins.slice(0, -1).concat(metaCoins))[this.from_currency].symbol :
                        coins[this.from_currency].symbol;
                } else {
                    return coins[Array.from(Object.keys(this.absolute_currencies))[this.from_currency]].symbol;
                }
            },
            toCoin() {
                const currentPoolObj = this.currentPoolObj;

                if (currentPoolObj.isFactoryOnlyPool && currentPoolObj.factoryVersion === 1) {
                    const { coins, metaCoins } = currentPoolObj;
                    return (coins.slice(0, -1).concat(metaCoins))[this.to_currency];
                } else if (currentPoolObj.isFactoryOnlyPool && currentPoolObj.factoryVersion === 2) {
                    const { isMetaPool, coins, metaCoins } = currentPoolObj;
                    return isMetaPool ?
                        (coins.slice(0, -1).concat(metaCoins))[this.to_currency] :
                        coins[this.to_currency];
                } else {
                    return coins[Array.from(Object.keys(this.absolute_currencies))[this.to_currency]];
                }
            },
            toSymbol() {
                return this.toCoin.symbol;
            },
            defaultMaxSlippage() {
                return (this.isCryptoPool || this.crossAssetSwap) ? 0.5 : 0.1;
            },
            effectiveMaxSlippage() {
                return (
                    this.customSlippageDisabled ?
                        (this.maxSlippage || this.defaultMaxSlippage) :
                        this.maxInputSlippage
                );
            },
        },
        mounted() {
            const isNative = pools.getById(currentContract.currentContract).isNative;
            if(currentContract.initializedContracts) this.mounted();
        },
        methods: {
            async mounted() {
                const pool = pools.getById(currentContract.currentContract);

                if(pool.referenceAsset === REFERENCE_ASSETS.CRYPTO || pool.referenceAsset !== REFERENCE_ASSETS.USD) {
                    await this.updatePoolAssetsUsdPrice();
                }

                if(pool.referenceAsset === REFERENCE_ASSETS.BTC || pool.referenceAsset === REFERENCE_ASSETS.ETH) {
                    this.fromInput = '0.0001'
                }

                this.c_rates = currentContract.c_rates
                this.coinsContractsArray = currentContract.underlying_coins
                if(this.swapwrapped) {
                    this.coinsContractsArray = currentContract.coins
                }

                if(this.is_meta && this.swapwrapped) {
                    this.c_rates = currentContract.c_rates.slice(0,2)
                    this.coinsContractsArray = currentContract.all_coins.slice(0,2)
                }

                if(this.is_meta && !this.swapwrapped) {
                    this.c_rates = [currentContract.c_rates[0], ...currentContract.c_rates.slice(2)]
                    this.coinsContractsArray = [currentContract.all_coins[0], ...currentContract.all_coins.slice(2)]
                }

                this.disabled = false;
                this.from_cur_handler()
                this.to_cur_handler()
            },
            async updatePoolAssetsUsdPrice() {
                const pool = pools.getById(currentContract.currentContract);
                const activeCurrenciesSymbols = Array.from(Object.values(this.currencies)).map((symbol) => symbol.toLowerCase());

                /**
                 * Displayed currencies sometimes display ETH when the underlying
                 * is WETH; since we use display currencies as the single source of truth
                 * for what currencies are contained in this pool, we simply attach
                 * 'eth'<>weth.address to the map of token prices to retrieve, so that
                 * pools displaying eth while having weth underneath still get the price fetched.
                 */
                const poolCoinsSymbolAddressMap = helpers.arrayToHashmap([
                    ...pool.coins,
                    ...(pool.metaCoins || []),
					{ symbol: coins[config.nativeAssetId].symbol, address: coins[config.nativeAssetErc20WrapperId].address },
                ].map(({ address, symbol }) => [symbol.toLowerCase(), address]));

                this.poolAssetsUsdPrice = await getPricesArrayForTokens(activeCurrenciesSymbols.map((symbol) => poolCoinsSymbolAddressMap[symbol]));
            },
            getTokenIcon(token) {
                const symbol = this.currentPoolObj.isFactoryOnlyPool ?
                    ((this.currencies && this.currencies[token]) || '').toLowerCase() :
                    token;
                const isFactoPoolV2 = (this.currentPoolObj.isFactoryOnlyPool && this.currentPoolObj.factoryVersion === 2);

                const address = (
                    (isFactoPoolV2 && symbol !== config.nativeAssetId?.toLowerCase()) ?
                        this.currentPoolObj.coins.find((coin) => coin.symbol.toLowerCase() === symbol)?.address?.toLowerCase() :
                        undefined
                );

                return helpers.getTokenIcon(address || symbol);
            },
            getPair(inverse = false) {
                let from;
                let to;

                if (this.currentPoolObj.isFactoryOnlyPool) {
                    from = this.currencies[this.from_currency];
                    to = this.currencies[this.to_currency];
                } else {
                    from = !this.swapwrapped ? Object.keys(this.currencies)[this.from_currency] : Object.values(this.currencies)[this.from_currency]
                    to = !this.swapwrapped ? Object.keys(this.currencies)[this.to_currency] : Object.values(this.currencies)[this.to_currency]
                    from = helpers.capitalize(from)
                    to = helpers.capitalize(to)
                }

                if(!inverse) return from + '/' + to
                if(inverse) return to + '/' + from
            },
            toFixed(num) {
                if(num == '' || num == undefined || +num == 0) return '0.00'
                if(!BigNumber.isBigNumber(num)) num = +num

                let decimals = pools.getById(currentContract.currentContract).referenceAsset === REFERENCE_ASSETS.USD ? 2 : 8;
								if (pools.getById(currentContract.currentContract).cryptoPool) decimals = 8

                return num.toFixed(decimals);
            },
            swapInputs() {
                //look no temp variable! :D
                [this.fromInput, this.toInput] = [this.toInput, this.fromInput]
                this.from_currency = this.to_currency
                this.from_cur_handler()
            },
            swapExchangeRate() {
                if(isNaN(this.exchangeRate)) return;
                this.swaprate = !this.swaprate
            },
			calcExchangeRate(dy_, dx_) {
                console.log('calcExchangeRate', { dy_, dx_ })
				let exchangeRate = (dy_ / dx_)

				if(this.swapwrapped) {
					let cdy_ = (dy_ * this.c_rates[this.to_currency] * contractAbis[currentContract.currentContract].wrapped_precisions[this.to_currency])
					let cdx_ = (dx_ * this.c_rates[this.from_currency] * contractAbis[currentContract.currentContract].wrapped_precisions[this.from_currency])
					exchangeRate = (cdy_ / cdx_)
				}

				return exchangeRate;
			},
            async set_to_amount() {
				const {
                    cryptoPool: isCryptoPool,
                    id: poolId,
                    isStablePoolWithSpecialUnpeggedAssets,
                } = pools.getById(currentContract.currentContract);

                this.promise.cancel()
                let promise = this.setAmountPromise()
				let promise2;
				let promise3;

                const needsCryptoSlippageCalc = (
                    isStablePoolWithSpecialUnpeggedAssets ||
                    isCryptoPool
                );

                /**
                 * Some crypto pools suffer from a minor issue that prevents returning a correct dy value
                 * when their A parameter is ramping. Executing a trade has no issues, but calculating the
                 * output of a trade before actually making that trade suffers this minor issue when A is
                 * ramping, so we need to use another more convoluted method to calculated the exchange
                 * rate for these pools. Ideally we'd only run this special calculations (1) for these pools,
                 * and (2) when ramping, but since these pools are a minority, and the difference between the
                 * actual dy and the result of this special calculation is virtually inexistent when A is *not*
                 * ramping, we simply use this special calculation method all the time for these pools.
                 */
                const needsSpecialExchangeRateCalculation = (
                    needsCryptoSlippageCalc &&
                    config.cryptoPoolsThatNeedSpecialRateCalculationWhenRamping?.includes(poolId)
                );

				// Calculate output amount for smallest unit
				if (needsCryptoSlippageCalc) {
                    const poolBalanceForSelectedFromCurrency = this.bal_info[this.from_currency];
                    const poolAssetCount = this.bal_info.length;
                    const poolTotalBalanceFromCurrencyEquiv = poolBalanceForSelectedFromCurrency * poolAssetCount;
                    const smallUnit = poolTotalBalanceFromCurrencyEquiv * 1e-6;

					// Prevent div-by-zero by preventing small unit being equal to the input amount
					if (parseFloat(this.fromInput) === smallUnit) smallUnit -= 1e-6;

					this.promise2.cancel();
	                promise2 = this.setAmountPromise(smallUnit);

                    if (needsSpecialExchangeRateCalculation) {
                        const smallUnitX2 = smallUnit * 2;

    					this.promise3.cancel();
    	                promise3 = this.setAmountPromise(smallUnitX2);
                    }
				}

                this.interval && !this.interval.stopped && clearIntervalAsync(this.interval)
                // if(typeof (+this.fromInput) === 'number' && !isNaN(+this.fromInput))
                //     this.interval = setIntervalAsync(this.set_to_amount, 3000)
                try {
                    let [dy, dy_, dx_, balance] = await promise

					let exchangeRate;

					if (needsCryptoSlippageCalc) {
                        if (!needsSpecialExchangeRateCalculation) {
                            const [, dy2_, dx2_] = await promise2;

                            const exchangeRateSmallUnit = dy2_ / dx2_;
                            const exchangeRateRealAmount = dy_ / dx_;

                            this.cryptoTradeSlippage = 1 - (exchangeRateRealAmount / exchangeRateSmallUnit);
                            exchangeRate = exchangeRateRealAmount;
                            this.toInput = dy;
                        } else {
                            const [, dy2_, dx2_] = await promise2;
    						const [, dy3_, dx3_] = await promise3;

                            const y2 = dy_;
                            const x2 = dx_;
                            const y0 = dy2_;
                            const x0 = dx2_;
                            const y1 = dy3_;
                            const x1 = dx3_;
                            const slippage = 1 - ((y2 - y0) / (x2 - x0) / ((y1 - y0) / (x1 - x0)));
                            this.cryptoTradeSlippage = slippage;

                            exchangeRate = (y2 - y0) / (x2 - x0);
                            this.toInput = x2 * exchangeRate;
                        }
					} else {
                        this.toInput = dy;
                        exchangeRate = this.calcExchangeRate(dy_, dx_);

                        this.cryptoTradeSlippage = undefined;
                        if(exchangeRate <= 0.98) this.bgColor = 'red'
                        else this.bgColor= '#505070'
					}

                    this.exchangeRate = isCryptoPool ?
                        truncWithXSignificantDecimals(exchangeRate, 4) :
                        exchangeRate.toFixed(4);

                    if(isNaN(this.exchangeRate)) this.exchangeRate = "Not available"
                    let amount = Math.floor(
                            100 * parseFloat(balance) / this.precisions[this.to_currency]
                        ) / 100

                    this.disabled = false;
                }
                catch(err) {
                    console.error(err)
                    this.disabled = true
                }
                finally {
                    this.set_from_amount(this.from_currency);
                }
                this.promise = helpers.makeCancelable(promise)
                this.promise2 = helpers.makeCancelable(promise2)
                this.promise3 = helpers.makeCancelable(promise3)
            },
            async from_cur_handler() {
                if(this.from_currency > Object.keys(this.currencies).length - 1)
                    this.from_currency = 0

                this.from_currency_id = this.currentPoolObj.isFactoryOnlyPool ?
                    this.currencies[this.from_currency] :
                    Object.keys(this.currencies)[this.from_currency];

								let currentAllowance = 0;
								if (this.from_currency_id === config.nativeAssetId) {
									//set eth allowance to amx cause we don't need one
									currentAllowance = currentContract.max_allowance.div(cBN(2))
								} else {
									currentAllowance = cBN(await this.coinsContractsArray[this.from_currency].methods.allowance(this.default_account, currentContract.swap_address).call())
								}

                let maxAllowance = currentContract.max_allowance.div(cBN(2))
                if (currentAllowance.gt(maxAllowance))
                    this.inf_approval = true;
                else
                    {
											//this.inf_approval = false;
										}

                await this.set_from_amount(this.from_currency);

                await this.set_to_amount();

            },
            async to_cur_handler() {
                if (this.to_currency == this.from_currency) {
                    if (this.to_currency == 0) {
                        this.from_currency = 1;
                    } else {
                        this.from_currency = 0;
                    }
                    await this.set_from_amount(this.from_currency);
                }

                this.to_currency_id = Object.keys(this.currencies)[this.to_currency];

                await this.set_to_amount();
            },
            async set_max_balance() {
                let balance
                if(!this.currentPoolObj.isFactoryOnlyPool && coins[this.from_currency_id].isSynth) {
                    balance = await this.coinsContractsArray[this.from_currency].methods.transferableSynths(this.default_account).call();
                    if(this.susdWaitingPeriod) balance = 0
                }
                else if (this.from_currency_id === config.nativeAssetId) {
									balance = await currentContract.web3.eth.getBalance(this.default_account);
									balance = balance - 10000000000000000;
								} else {
									balance = await this.coinsContractsArray[this.from_currency].methods.balanceOf(this.default_account).call();
								}
                let amount = cBN(balance).div(this.precisions[this.from_currency]).toFixed()
                this.fromInput = currentContract.default_account ? amount : 0
                await this.set_to_amount();
            },
            async highlight_input() {
                let balanceCall = this.coinsContractsArray[this.from_currency].methods.balanceOf(this.default_account).call()
                let balance = parseFloat(await this.coinsContractsArray[this.from_currency].methods.balanceOf(this.default_account).call()) /
                        this.precisions[this.from_currency];
                if (this.fromInput > balance)
                    this.fromBgColor = 'red'
                else
                    this.fromBgColor = 'blue'
            },
            async set_from_amount(i) {
                let balanceCalls = [[this.coinsContractsArray[i]._address, this.coinsContractsArray[i].methods.balanceOf(this.default_account).encodeABI()]]

                if(!this.currentPoolObj.isFactoryOnlyPool && coins[this.from_currency_id].isSynth) {
                    balanceCalls.push([this.coinsContractsArray[i]._address, this.coinsContractsArray[i].methods.transferableSynths(this.default_account).encodeABI()])
                    let currencyKey = '0x7355534400000000000000000000000000000000000000000000000000000000'

										if(['tbtc', 'sbtc', 'pbtc', 'bbtc', 'obtc'].includes(this.currentPool))
												currencyKey = '0x7342544300000000000000000000000000000000000000000000000000000000'

										if(['seth'].includes(this.currentPool)) {
												currencyKey = '0x7345544800000000000000000000000000000000000000000000000000000000'
												this.waitingAsset = 'sETH';
										}

										if(['eurs'].includes(this.currentPool)) {
												currencyKey = '0x7345555200000000000000000000000000000000000000000000000000000000'
												this.waitingAsset = 'sEUR';
										}

										if(['link'].includes(this.currentPool)) {
												currencyKey = '0x734c494e4b000000000000000000000000000000000000000000000000000000'
												this.waitingAsset = 'sLINK';
										}

                    balanceCalls.push([
                        currentContract.snxExchanger._address,
                        currentContract.snxExchanger.methods
                        .maxSecsLeftInWaitingPeriod(currentContract.default_account,  currencyKey )
                        .encodeABI()
                    ])
                }

									//console.log('balanceCalls', balanceCalls);
								let amounts = [];

								if (this.from_currency_id === config.nativeAssetId) {
									let balance = await currentContract.web3.eth.getBalance(this.default_account);
									amounts.push(balance);

								} else {
									let aggcalls = await currentContract.multicall.methods.aggregate(balanceCalls).call()
									let balances = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))
									amounts = balances.map(balance => currentContract.default_account ? balance : 0)
								}

                this.maxBalance = amounts[0]
                let highlight_red = this.fromInput > this.maxBalance / this.precisions[this.from_currency]
                if(!this.currentPoolObj.isFactoryOnlyPool && coins[this.from_currency_id].isSynth) {
                    this.maxSynthBalance = cBN(amounts[1]).div(1e18).toFixed()
                    this.susdWaitingPeriod = (+amounts[2] != 0)
                    this.susdWaitingPeriodTime = +amounts[2]
                    highlight_red = this.fromInput > this.maxSynthBalance
                    if(this.susdWaitingPeriod) highlight_red = true
                }
                if(highlight_red)
                    this.fromBgColor = 'red'
                else
                    this.fromBgColor = 'blue'
            },
            setAmountPromise(fromInputOverride = undefined) {
                let promise = new Promise(async (resolve, reject) => {
                    var i = this.from_currency;
                    var j = this.to_currency;

                    var dx_ = fromInputOverride || this.fromInput;
                    var dx = cBN(Math.round(dx_ * this.precisions[i])).toFixed(0,1);
                    let calls = []

                    // console.log('setAmountPromise', {
                    //     i, j, dx_, dx,
                    //     'this.precisions': this.precisions
                    // })


										//// NOTE: do we need this?? charlie

                    // if(this.is_meta && i > 0) {
                    //     calls = [
                    //         [currentContract.base_swap._address, currentContract.base_swap.methods.balances(i-1).encodeABI()]
                    //     ]
                    // }

										if(!this.swapwrapped && (this.currentPoolObj.isLendingPool || this.currentPoolObj.isMetaPool)) {
                                            const isFactoCryptoMetaPool = (
                                                this.currentPoolObj.isMetaPool &&
                                                this.currentPoolObj.isFactoryOnlyPool &&
                                                this.isCryptoPool
                                            );
                                                if (isFactoCryptoMetaPool) {
                                                    // get_dy is like get_dy_underlying on those pools' zap
                                                    calls.push([currentContract.deposit_zap._address, currentContract.deposit_zap.methods.get_dy(this.currentPoolObj.addresses.swap, i, j, dx).encodeABI()])
                                                } else if (this.currentPoolObj.isForexMetaPool) {
													//get_dy_underlying is in the zap on crypto metapools
													calls.push([currentContract.deposit_zap._address, currentContract.deposit_zap.methods.get_dy_underlying(i, j, dx).encodeABI()])
												} else {
													calls.push([currentContract.swap._address, currentContract.swap.methods.get_dy_underlying(i, j, dx).encodeABI()])
												}
                    }
										else if (this.currentPoolObj.isFakePlainPool) {
											//get_dy but on the zap
											calls.push([currentContract.crypto_zap._address, currentContract.crypto_zap.methods.get_dy_underlying(i, j, dx).encodeABI()])
										}
                    else {
                        //dx = cBN(dx).times(currentContract.c_rates[i])
                        calls.push([currentContract.swap._address, currentContract.swap.methods.get_dy(i, j, dx).encodeABI()])
                    }

                    calls.push([this.coinsContractsArray[this.to_currency]._address , this.coinsContractsArray[this.to_currency].methods.balanceOf(this.default_account).encodeABI()])

                    // remove call to check balance of eth which is 0xeeeeeee and throws an error
                    calls = calls.filter(([address]) => address.toLowerCase() !== '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');

					let aggcalls = config.blockchainId === 'ethereum' ?
                        await currentContract.multicall.methods.aggregate(calls).call(undefined, 'pending') :
                        await currentContract.multicall.methods.aggregate(calls).call();

                    let decoded = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))
                    let [get_dy_underlying, balance] = decoded
                    // In c-units
                    var dy_ = +get_dy_underlying / this.precisions[j];
                    var dy = this.toFixed(dy_);
                    console.log({ dy_, dy, jprec: this.precisions[j] })
                    resolve([dy, dy_, dx_, balance])
                })
                return helpers.makeCancelable(promise);
            },
            setLoadingAction() {
                this.loadingAction = true
                setTimeout(() => this.loadingAction = false, 500)
            },
            bypassGasEstimationFailureWarning() {
                this.showFailedGasEstimationModal = false;
                this.handle_trade({ bypassGasEstimationFailureWarning: true });
            },
            async handle_trade({ bypassGasEstimationFailureWarning = false }) {
                if(this.loadingAction) return;
                this.userInteracted = true
                this.setLoadingAction();

                const pool = pools.getById(currentContract.currentContract);

                const isFactoCryptoMetaPool = (
                    pool.isMetaPool &&
                    pool.isFactoryOnlyPool &&
                    this.isCryptoPool
                );

                this.show_loading = true;
                var i = this.from_currency
                var j = this.to_currency;

                let maxSlippage = this.effectiveMaxSlippage / 100;
                let currency = (Object.keys(this.currencies)[this.from_currency]).toUpperCase()
                if(this.swapwrapped) currency = Object.values(this.currencies)[this.from_currency]
                if (pool.isFactoryOnlyPool && pool.factoryVersion === 2) {
                    currency = Object.values(this.currencies)[this.from_currency];
                }
				var dx = BN(this.fromInput).times(this.precisions[i]).toFixed();
                if(BN(this.maxBalance).gt(0) && BN(this.maxBalance).div(this.precisions[i]).minus(BN(this.fromInput)).lt(BN(this.minAmount))) {
                    dx = this.maxBalance
                }
                if(
                    (!this.currentPoolObj.isFactoryOnlyPool && coins[this.from_currency_id].isSynth) &&
                    BN(this.maxSynthBalance).gt(0) &&
                    BN(this.maxSynthBalance).minus(BN(this.fromInput)).lt(BN(this.minAmount))
                ) {
                    dx = BN(this.maxSynthBalance).times(1e18).toFixed(0,1)
                }
                let min_dy_method = 'get_dy_underlying'
                if(this.swapwrapped || (!this.currentPoolObj.isLendingPool && !this.currentPoolObj.isMetaPool)) {
                    min_dy_method = 'get_dy'
                }
								if (isFactoCryptoMetaPool) {
									var min_dy = BN(await currentContract.deposit_zap.methods.get_dy(pool.addresses.swap, i, j, BN(dx).toFixed(0,1)).call())
								} else if (this.currentPoolObj.isFakePlainPool) {
									min_dy_method = 'get_dy_underlying'
									var min_dy = BN(await currentContract.crypto_zap.methods[min_dy_method](i, j, BN(dx).toFixed(0,1)).call())
								} else if (this.currentPoolObj.isForexMetaPool) {
									min_dy_method = 'get_dy_underlying'
									var min_dy = BN(await currentContract.deposit_zap.methods[min_dy_method](i, j, BN(dx).toFixed(0,1)).call())
								} else {
									var min_dy = BN(await currentContract.swap.methods[min_dy_method](i, j, BN(dx).toFixed(0,1)).call())
								}
								//

                min_dy = min_dy.times(1-maxSlippage)
                dx = cBN(dx.toString()).toFixed(0,1);
                const currencySymbol = (
                    (pool.isFactoryOnlyPool && pool.factoryVersion === 2) ? this.currencies[this.from_currency] :
                    this.currentPoolObj.isFactoryOnlyPool ? this.currencies[this.from_currency_id] :
                    coins[this.from_currency_id].symbol
                );
                this.waitingMessage = `Please approve ${this.fromInput} ${currencySymbol} for exchange`
                var { dismiss } = notifyNotification(this.waitingMessage)
                try {
                    const currencyIds = Array.from(Object.keys(this.currencies));
                    console.log({ currencyIds })

                    await common.ensure_underlying_allowance(currencyIds[i], dx, undefined, this.swapwrapped);
                }
                catch(err) {
                    console.error(err)
                    dismiss()
                    this.waitingMessage = ''
                    this.show_loading = false
                    throw err;
                }
                dismiss()

                min_dy = cBN(min_dy).toFixed(0);
                let exchangeMethod = currentContract.swap.methods.exchange_underlying
                let exchangeMethodName = 'exchange_underlying';
                if(this.swapwrapped || (!this.currentPoolObj.isLendingPool && !this.currentPoolObj.isMetaPool)) {
                    exchangeMethod = currentContract.swap.methods.exchange
                    exchangeMethodName = 'exchange';
                }

								if (this.currentPoolObj.isFakePlainPool) {
									exchangeMethodName = 'exchange_underlying';
								}

								if (this.currentPoolObj.isForexMetaPool) {
									exchangeMethodName = 'exchange_underlying';
									exchangeMethod = currentContract.deposit_zap.methods.exchange_underlying
								}

								let ethValue  = 0;

								if (this.from_currency_id === config.nativeAssetId) {
									ethValue = BN(this.fromInput).times(1e18)
								}


				try {
                    if (config.blockchainId === 'ethereum' && !isFactoCryptoMetaPool) {
                        let estimateGas = 0;
                        const params = (pool.allowTradingEth && !this.swapWrappedEth) ?
                            [i, j, dx, BN(min_dy).toFixed(0,1), true] :
                            [i, j, dx, BN(min_dy).toFixed(0,1)];

                        try {
                            estimateGas = await exchangeMethod(...params)
                                    .estimateGas({
                                            from: currentContract.default_account,
                                            value: ethValue,
                                            gas: this.swapwrapped ?
                                                            contractGas.swap[this.currentPool].exchange(i, j) : contractGas.swap[this.currentPool].exchange_underlying(i, j),
                                    })

                            this.estimateGas = estimateGas
                            estimateGas = (estimateGas * 1.2);
                            estimateGas = estimateGas.toFixed(0)
                            this.errorEstimating = null;
                            this.showFailedGasEstimationModal = false;
                        } catch (e) {
                            this.errorEstimating = true;
                            this.showFailedGasEstimationModal = true;
                            estimateGas = this.swapwrapped ?
                                            contractGas.swap[this.currentPool].exchange(i, j) : contractGas.swap[this.currentPool].exchange_underlying(i, j);
                            this.estimateGas = estimateGas
                        }

                        // If there's a gas estimation failure warning to display, and user hasn't already
                        // bypassed it by clicking "proceed nonetheless", abort trade and let the modal show.
                        if (this.showFailedGasEstimationModal && !bypassGasEstimationFailureWarning) {
                            dismiss();
                            this.waitingMessage = '';
                            this.show_loading = false;
                            return;
                        }
                        this.showFailedGasEstimationModal = false;

                        await helpers.setTimeoutPromise(100)

                        this.waitingMessage = `Please confirm swap
                                                from ${this.fromInput} ${this.currentPoolObj.isFactoryOnlyPool ? (this.currencies[this.from_currency_id] || coins[this.from_currency_id].symbol) : coins[this.from_currency_id].symbol}
                                                for min ${this.toFixed(min_dy / this.precisions[j])} ${this.currentPoolObj.isFactoryOnlyPool ? this.currencies[this.to_currency_id] : coins[this.to_currency_id].symbol}`
                        var { dismiss } = notifyNotification(this.waitingMessage)

                        await helpers.setTimeoutPromise(100)

                        console.log('Prepare: ',{
                            exchangeMethod,
                            params
                        })

                        await (await sendSafe(exchangeMethod(...params), {
                                from: currentContract.default_account,
								value: ethValue,
                                gas: estimateGas
                            })).pe
                            .once('transactionHash', hash => {
                                dismiss()
                                notifyHandler(hash)
                                this.waitingMessage = `Waiting for swap
                                                        <a href='${config.explorerBaseUrl.tx}${hash}'>transaction</a>
                                                        to confirm: no further action needed`
                            })
                    } else {
                        let params;
                        let contractName;

                        if (isFactoCryptoMetaPool) {
                            contractName = 'deposit_zap';
                            exchangeMethodName = 'exchange';
                            params = [pool.addresses.swap, i, j, BN(dx).toFixed(0,1), BN(min_dy).toFixed(0,1)];
                        } else {
                            params = (
                                (pool.allowTradingEth && !this.swapWrappedEth) ?
                                    [i, j, dx, BN(min_dy).toFixed(0,1), 1] :
                                (this.currentPoolObj.isFactoMetaPoolAndTwoLevelsDeep) ?
                                    [this.currentPoolObj.addresses.swap, i, j, dx, BN(min_dy).toFixed(0,1)] :
                                    [i, j, dx, BN(min_dy).toFixed(0,1)]
                            );

                            if (this.currentPoolObj.isForexMetaPool) {
                                params = [i, j, dx, BN(min_dy).toFixed(0,1)]
                            }

                            console.log({params}, 'params')

                            contractName = this.currentPoolObj.isFakePlainPool ? 'crypto_zap' :
                            (this.currentPoolObj.isFactoMetaPoolAndTwoLevelsDeep) ? 'deposit_zap' :
                            'swap'

                            if (this.currentPoolObj.isForexMetaPool) {
                                contractName = 'deposit_zap'
                            }

                            console.log({contractName})
                        }

                        await callMethod({
                            contract: currentContract,
														contractName: contractName,
                            fromAddress: currentContract.default_account,
                            methodName: exchangeMethodName,
                            params,
                            extraData: {
                                'ethValue': ethValue.toFixed(0),
                                ethereumContractGasEstimationFallback: 0,
                            },
                            vueState: {
                                vueInstance: this,
                                initialWaitingMessage: `Please confirm swap from ${this.fromInput} ${this.currentPoolObj.isFactoryOnlyPool ? (this.currencies[this.from_currency_id] || this.currencies[this.from_currency] || coins?.[this.from_currency_id]?.symbol) : coins[this.from_currency_id].symbol} for min ${this.toFixed(min_dy / this.precisions[j])} ${this.currentPoolObj.isFactoryOnlyPool ? (this.currencies[this.to_currency_id] || this.currencies[this.to_currency]) : coins[this.to_currency_id].symbol}`,
                                pendingWaitingMessage: `Waiting for swap <a href="[TX_URL]">transaction</a> to confirm: no further action needed`,
                            },
                        });
                    }
                }
                catch(err) {
                    console.error(err)
                    dismiss()
                    errorStore.handleError(err)
                    this.waitingMessage = '';
                    this.show_loading = '';
                    throw err;
                }
                this.waitingMessage = ''
                this.show_loading = false;
                this.estimateGas = 0;
                await common.update_fee_info();
                this.from_cur_handler();
                let balance = await this.coinsContractsArray[i].methods.balanceOf(this.default_account).call();
                this.maxBalance = balance;
            }
        },

        beforeDestroy() {
            this.interval && clearIntervalAsync(this.interval)
        },
    }
</script>

<style scoped>
	.actualvalue {
        margin: 0.5em 0 0 0;
        text-align: right;
        font-size: 0.9em;
    }
    /*#no-balance {
        text-align: center;
    }*/
    .swapBTC-container {
        margin-top: 1em;
    }
    .pulse {
        animation: pulse 1s 3;
        margin-bottom: 8px;
    }
    .advancedoptions {
        margin-top: 1em;
    }
    .advancedoptions + div legend {
        text-align: center;
    }
    .button-container {
        padding-top: 1em;
        text-align: center;
    }
    .buttoncancel {
        margin-right: 1em;
    }
    .buttonred {
        background: red;
        border: 1px outset red;
    }
    .buttonred:hover {
        background: red;
        border: 1px outset red;
    }
    .modal-content.failed-gas-estimation {
        width: 400px;
    }
    .price-impact.red {
        font-weight: bold;
        color: red;
    }
</style>
